(function () {
  'use strict';

  var L = window.MaxisQuizLogic;
  var CFG = window.MAXIS_QUIZ || { products: {}, discountCode: 'QUIZ15', discountPct: 15 };
  var root = document.querySelector('[data-quiz-root]');
  if (!root || !L) return;

  // ============================================================
  //  CONTENU — Quiz MAXIS V1 (spec docs/quizz_maxis_v1.md)
  //  10 questions ; les écrans (réassurance, loaders, résultat,
  //  projection, offre) s'intercalent via FLOW plus bas.
  // ============================================================
  var QUESTIONS = {
    q_age: { id: 'q_age', q: 'Quel âge as-tu ?', options: [
      { value: '50+',   label: '50 ans et plus', scores: {} },
      { value: '40-49', label: '40–49 ans',      scores: {} },
      { value: '30-39', label: '30–39 ans',      scores: {} },
      { value: '20-29', label: '20–29 ans',      scores: {} }
    ]},
    q_concern: { id: 'q_concern', q: 'C\'est quoi ta préoccupation numéro 1 en ce moment ?', options: [
      { value: 'energie', label: '⚡ Mon niveau d\'énergie',                scores: { energie: 3 } },
      { value: 'focus',   label: '🧠 Ma concentration / clarté mentale',   scores: { energie: 2, stress: 1 } },
      { value: 'stress',  label: '😮‍💨 Mon stress / ma tension nerveuse',    scores: { stress: 3 } },
      { value: 'sommeil', label: '😴 Mon sommeil / ma récupération',        scores: { sommeil: 3 } },
      { value: 'barre',   label: '🔋 Mes coups de barre dans la journée',   scores: { energie: 2, sommeil: 1 } }
    ]},
    q_symptomes: { id: 'q_symptomes', q: 'Dans la journée, tu te sens souvent fatigué, irritable, dans le brouillard ou à cran ?', options: [
      { value: 'oui',      label: 'Oui, régulièrement', scores: { stress: 2, energie: 1 } },
      { value: 'parfois',  label: 'De temps en temps',  scores: { stress: 1 } },
      { value: 'rarement', label: 'Rarement',           scores: {} }
    ]},
    q_crash15h: { id: 'q_crash15h', q: 'Ton énergie à 15h, comparée au réveil, c\'est quoi ?', options: [
      { value: 'vide',    label: '🪫 Complètement vidé — il me faut un café ou une sieste', scores: { energie: 3 } },
      { value: 'bas',     label: '😴 Nettement plus bas — le coup de barre me tombe dessus', scores: { energie: 2 } },
      { value: 'ralenti', label: '😐 Un peu fatigué — fonctionnel mais au ralenti',          scores: { energie: 1 } },
      { value: 'stable',  label: '⚡ Même énergie — pas de crash',                            scores: {} }
    ]},
    q_anciennete: { id: 'q_anciennete', q: 'Depuis quand tu remarques ces changements d\'énergie ?', options: [
      { value: '>1an',     label: 'Il y a plus d\'un an', scores: {} },
      { value: '<1an',     label: 'Dans l\'année écoulée', scores: {} },
      { value: 'recent',   label: 'Ces derniers mois',     scores: {} },
      { value: 'sais-pas', label: 'Je ne sais pas trop',   scores: {} }
    ]},
    q_reveils: { id: 'q_reveils', q: 'Il t\'arrive de te réveiller la nuit sans raison, souvent autour de 3h ?', options: [
      { value: 'souvent',  label: 'Oui, presque toutes les nuits', scores: { sommeil: 3 } },
      { value: 'parfois',  label: 'Quelques fois par semaine',     scores: { sommeil: 2 } },
      { value: 'rarement', label: 'Rarement',                      scores: {} }
    ]},
    q_sommeil: { id: 'q_sommeil', q: 'Combien d\'heures de sommeil VRAIMENT réparateur tu as par nuit ?', options: [
      { value: 'moins5',     label: 'Moins de 5h',                      scores: { sommeil: 3, energie: 1 } },
      { value: '5-6',        label: '5–6h',                             scores: { sommeil: 2 } },
      { value: '7-8fatigue', label: '7–8h mais je me réveille fatigué', scores: { sommeil: 2 } },
      { value: '7-8repose',  label: '7–8h et je me réveille reposé',    scores: {} }
    ]},
    q_decrocher: { id: 'q_decrocher', q: 'Le soir, tu arrives à vraiment décrocher, ou ton mental continue de tourner ?', options: [
      { value: 'rumine', label: 'Impossible de couper, je rumine',     scores: { stress: 3, sommeil: 1 } },
      { value: 'lent',   label: 'Ça prend du temps mais j\'y arrive',   scores: { stress: 1 } },
      { value: 'facile', label: 'Je décroche facilement',              scores: {} }
    ]},
    q_alimentation: { id: 'q_alimentation', q: 'Tu manges à quelle fréquence des aliments transformés / industriels ?',
      why: 'L\'alimentation moderne et les sols appauvris fournissent de moins en moins de magnésium et de minéraux essentiels. Plus ton alimentation est transformée, plus le déficit se creuse.',
      options: [
      { value: 'tousjours',  label: 'Tous les jours, à la plupart des repas', scores: { energie: 2 } },
      { value: 'souvent',    label: 'Plusieurs fois par semaine',             scores: { energie: 1 } },
      { value: 'occasionnel', label: 'Occasionnellement, surtout du brut',    scores: {} },
      { value: 'rare',       label: 'Rarement, j\'évite l\'ultra-transformé',  scores: {} }
    ]},
    q_deja_essaye: { id: 'q_deja_essaye', q: 'Tu as déjà testé des compléments (magnésium, multivitamines…) sans rien ressentir ?', options: [
      { value: 'oui-rien',  label: 'Oui, et ça n\'a rien changé', scores: {} },
      { value: 'oui-leger', label: 'Oui, avec un léger effet',    scores: {} },
      { value: 'non',       label: 'Non, jamais essayé',          scores: {} }
    ]}
  };

  // Séquence exacte de la spec : questions + écrans intercalés.
  var FLOW = [
    { t: 'q', id: 'q_age' },
    { t: 'q', id: 'q_concern' },
    { t: 'q', id: 'q_symptomes' },
    { t: 'q', id: 'q_crash15h' },
    { t: 'q', id: 'q_anciennete' },
    { t: 'q', id: 'q_reveils' },
    { t: 's', view: 'reassurance' },
    { t: 'q', id: 'q_sommeil' },
    { t: 's', view: 'loader1' },
    { t: 'q', id: 'q_decrocher' },
    { t: 'q', id: 'q_alimentation' },
    { t: 'q', id: 'q_deja_essaye' },
    { t: 's', view: 'loader2' },
    { t: 's', view: 'result' },
    { t: 's', view: 'projection' },
    { t: 's', view: 'offer' }
  ];
  var TOTAL_Q = FLOW.filter(function (f) { return f.t === 'q'; }).length;

  // Liste pour computeScores (logique pure attend [{id, options}]).
  var QUESTION_LIST = FLOW.filter(function (f) { return f.t === 'q'; }).map(function (f) { return QUESTIONS[f.id]; });

  // ---------- Contenu des résultats (3 profils) ----------
  var RESULTS = {
    energie: {
      stackLabel: 'Stack Énergie',
      facteur: 'Déficit énergétique',
      cause: 'Manque de minéraux essentiels (magnésium, oligo-éléments)',
      body: 'Ton profil pointe vers un déficit énergétique de fond. Le crash de l\'après-midi, le recours au café, la fatigue malgré le sommeil : ce sont les signes d\'un corps qui manque des minéraux nécessaires pour produire son énergie au niveau cellulaire (ATP).',
      reco: [
        '<strong>Magnésium Advanced (Bisglycinate + Taurate)</strong> — contribue à un métabolisme énergétique normal et à réduire la fatigue',
        '<strong>Shilajit Himalaya</strong> — 85+ minéraux ioniques qui soutiennent ta fonction mitochondriale'
      ],
      bisglycinate: 'Tu as déjà testé le magnésium sans rien sentir ? Normal : l\'oxyde vendu en pharmacie s\'absorbe à peine. Le bisglycinate, c\'est une autre histoire.'
    },
    stress: {
      stackLabel: 'Stack Stress',
      facteur: 'Surcharge nerveuse',
      cause: 'Stress chronique + épuisement des réserves de magnésium',
      body: 'Ton profil pointe vers une surcharge du système nerveux. La tension permanente, le mental qui ne décroche pas, l\'irritabilité : sous stress chronique, ton corps épuise son magnésium plus vite qu\'il ne le remplace — et moins tu en as, moins tu encaisses. Un cercle vicieux.',
      reco: [
        '<strong>Magnésium Advanced (Bisglycinate + Taurate)</strong> — contribue à une fonction nerveuse et psychologique normale',
        '<strong>L-Théanine</strong> — apaise le mental sans somnolence, pour te calmer sans t\'éteindre'
      ],
      bisglycinate: 'Déjà testé le magnésium sans résultat ? La forme compte autant que la dose — le bisglycinate s\'absorbe bien mieux que l\'oxyde de pharmacie.'
    },
    sommeil: {
      stackLabel: 'Stack Sommeil',
      facteur: 'Sommeil non réparateur',
      cause: 'Sommeil profond insuffisant + système nerveux en surrégime',
      body: 'Ton profil pointe vers un sommeil qui ne répare plus. Les réveils nocturnes, le réveil fatigué malgré des heures suffisantes, le mental qui tourne au coucher : ton sommeil profond est tronqué, et c\'est lui qui détermine ta vraie récupération.',
      reco: [
        '<strong>Magnésium Advanced (Bisglycinate + Taurate)</strong> — apaise le système nerveux pour faciliter l\'endormissement',
        '<strong>Glycine</strong> — soutient un sommeil profond et réparateur'
      ],
      bisglycinate: 'Déjà testé le magnésium sans résultat ? La forme compte autant que la dose. L\'oxyde de pharmacie s\'absorbe mal — le bisglycinate change la donne.'
    }
  };

  var AGE_LABELS = { '50+': '50 ans et plus', '40-49': '40–49 ans', '30-39': '30–39 ans', '20-29': '20–29 ans' };

  // ---------- État ----------
  var state = {
    view: 'hook',      // hook | question | reassurance | loader1 | loader2 | result | projection | offer
    stepIndex: 0,      // index dans FLOW
    answers: {},
    scores: null,
    reco: null,
    lead: null,
    emailSent: false,
    trafficSource: L.parseTrafficSource(window.location.search)
  };

  var activeTimers = [];
  function clearTimers() { activeTimers.forEach(function (t) { clearTimeout(t); clearInterval(t); }); activeTimers = []; }

  // ---------- Tracking ----------
  function track(event, payload) {
    payload = payload || {};
    try { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: event }, payload)); } catch (e) {}
    try { if (window.fbq) window.fbq('trackCustom', event, payload); } catch (e) {}
    try { if (window.gtag) window.gtag('event', event, payload); } catch (e) {}
  }

  // ---------- Helpers ----------
  function money(cents) {
    var v = (Number(cents) || 0) / 100;
    return v.toFixed(2).replace('.', ',') + ' €';
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
    return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
  }); }
  function currentQuestion() {
    var step = FLOW[state.stepIndex];
    return step && step.t === 'q' ? QUESTIONS[step.id] : null;
  }
  function questionsDone() {
    var done = 0;
    for (var i = 0; i < state.stepIndex; i++) if (FLOW[i].t === 'q') done++;
    return done;
  }
  function hasPrevQuestion() {
    for (var i = state.stepIndex - 1; i >= 0; i--) if (FLOW[i].t === 'q') return true;
    return false;
  }
  function topBar() {
    var pct = Math.round((questionsDone() / TOTAL_Q) * 100);
    return '' +
      '<div class="mq-top">' +
        '<button class="mq-back" data-action="back" aria-label="Retour"' + (hasPrevQuestion() ? '' : ' hidden') + '>←</button>' +
        '<div class="mq-progress"><div class="mq-progress__bar" style="width:' + pct + '%"></div></div>' +
        '<span class="mq-progress__pct">' + pct + '%</span>' +
      '</div>';
  }
  function plus30Days() {
    var d = new Date();
    d.setDate(d.getDate() + 30);
    try { return d.toLocaleDateString('fr-FR', { day: 'numeric', month: 'long', year: 'numeric' }); }
    catch (e) { return d.toLocaleDateString(); }
  }

  // ---------- Registre de vues ----------
  var VIEWS = {};

  function render() {
    clearTimers();
    var fn = VIEWS[state.view];
    root.innerHTML = fn ? fn() : '';
    bindActions();
    if (fn && fn.after) fn.after();
    window.scrollTo(0, 0);
  }
  function go(view) { state.view = view; render(); }

  // Avance d'un pas dans FLOW (la vue est dérivée du type de pas).
  function enterStep(i) {
    if (i >= FLOW.length) return;
    state.stepIndex = i;
    var step = FLOW[i];
    if (step.t === 'q') { go('question'); }
    else {
      if (step.view === 'loader2' || step.view === 'result') ensureReco();
      go(step.view);
    }
  }
  function advance() { enterStep(state.stepIndex + 1); }
  function goBack() {
    for (var i = state.stepIndex - 1; i >= 0; i--) {
      if (FLOW[i].t === 'q') { enterStep(i); return; }
    }
  }
  function ensureReco() {
    if (state.reco) return;
    state.scores = L.computeScores(state.answers, QUESTION_LIST);
    state.reco = L.pickReco(state.scores);
    track('quiz_step', { step: 'questions_done', axe: state.reco && state.reco.axis });
  }

  function bindActions() {
    root.querySelectorAll('[data-action]').forEach(function (el) {
      el.addEventListener('click', onAction);
    });
  }
  function onAction(e) {
    var el = e.currentTarget;
    var action = el.getAttribute('data-action');
    if (action === 'start') { track('quiz_step', { step: 'start' }); enterStep(0); return; }
    if (action === 'back') { goBack(); return; }
    if (action === 'select') { onSelect(el); return; }
    if (action === 'continue') { advance(); return; }
    if (action === 'to-offer') { track('quiz_complete', { axe: state.reco && state.reco.axis }); advance(); return; }
    if (action === 'buy') { goToStack(); return; }
    if (action === 'reveal-email') { revealEmail(); return; }
  }

  // ---------- HOOK ----------
  VIEWS.hook = function () {
    return '' +
      '<section class="mq-screen mq-hook">' +
        '<div class="mq-urgency">⚡ Test de 2 minutes</div>' +
        '<h1 class="mq-h1">Découvre ce qui draine vraiment ton énergie</h1>' +
        '<p class="mq-sub">Ce test analyse tes symptômes, ton mode de vie et tes facteurs de risque pour identifier le levier qui te correspond.</p>' +
        '<blockquote class="mq-quote">« Pris sur les conseils de Flo. Franchement, résultat à la hauteur de mes attentes. » — Avis vérifié</blockquote>' +
        '<button class="mq-btn" data-action="start">Commencer le test</button>' +
        '<p class="mq-trust">Des centaines d\'hommes accompagnés · Satisfait ou remboursé 30 jours</p>' +
      '</section>';
  };

  // ---------- QUESTION ----------
  VIEWS.question = function () {
    var q = currentQuestion();
    if (!q) return '';
    var current = state.answers[q.id];
    var opts = q.options.map(function (o) {
      var on = current === o.value ? ' is-selected' : '';
      return '<button class="mq-option' + on + '" data-action="select" data-value="' + esc(o.value) + '">' + esc(o.label) + '</button>';
    }).join('');
    return topBar() +
      '<section class="mq-screen mq-question">' +
        '<h2 class="mq-h2">' + esc(q.q) + '</h2>' +
        '<div class="mq-options">' + opts + '</div>' +
        (q.why ? '<div class="mq-why"><strong>Pourquoi on demande :</strong> ' + esc(q.why) + '</div>' : '') +
      '</section>';
  };
  function onSelect(el) {
    var q = currentQuestion();
    var value = el.getAttribute('data-value');
    state.answers[q.id] = value;
    track('quiz_step', { step: q.id, value: value });
    advance();
  }

  // ---------- P7 RÉASSURANCE ----------
  VIEWS.reassurance = function () {
    return '' +
      '<section class="mq-screen mq-social">' +
        '<h2 class="mq-h2">Tu es au bon endroit.</h2>' +
        '<p class="mq-sub">La plupart des hommes mettent leur fatigue sur le dos de l\'âge ou du stress. La vraie cause est souvent plus simple — et corrigeable : un déficit en minéraux essentiels que l\'alimentation moderne ne fournit plus, aggravé par le stress et le manque de sommeil.</p>' +
        '<p class="mq-sub">Chez MAXIS, on ne masque pas le symptôme avec un stimulant. On corrige la cause, avec les bonnes formes, hautement assimilables.</p>' +
        '<blockquote class="mq-quote">Des centaines d\'hommes ont déjà retrouvé leur énergie sur les conseils de Flo et avec MAXIS Club.</blockquote>' +
        '<button class="mq-btn" data-action="continue">Continuer →</button>' +
      '</section>';
  };

  // ---------- P9 LOADER #1 (roue 0→100%) ----------
  VIEWS.loader1 = function () {
    return '' +
      '<section class="mq-screen mq-loader">' +
        '<div class="mq-spinner"></div>' +
        '<div class="mq-loader__pct" id="mq-pct">0%</div>' +
        '<h2 class="mq-h2">Analyse de ton profil en cours…</h2>' +
        '<p class="mq-sub">On croise tes réponses pour identifier les facteurs clés qui affectent ton énergie et ta vitalité.</p>' +
      '</section>';
  };
  VIEWS.loader1.after = function () {
    var el = root.querySelector('#mq-pct');
    var pct = 0;
    activeTimers.push(setInterval(function () {
      pct = Math.min(100, pct + 4);
      if (el) el.textContent = pct + '%';
    }, 120));
    activeTimers.push(setTimeout(function () { advance(); }, 3400));
  };

  // ---------- P13 LOADER #2 (étapes cochées) ----------
  VIEWS.loader2 = function () {
    return '' +
      '<section class="mq-screen mq-loader">' +
        '<div class="mq-spinner"></div>' +
        '<h2 class="mq-h2">On construit ton profil…</h2>' +
        '<div class="mq-loader__steps">' +
          '<div class="mq-loader__step" data-step="0">Analyse de tes symptômes</div>' +
          '<div class="mq-loader__step" data-step="1">Croisement avec ton mode de vie</div>' +
          '<div class="mq-loader__step" data-step="2">Calibrage de ton protocole</div>' +
          '<div class="mq-loader__step" data-step="3">Personnalisation de ton résultat</div>' +
        '</div>' +
        '<p class="mq-sub">Ton bilan personnalisé est presque prêt.</p>' +
      '</section>';
  };
  VIEWS.loader2.after = function () {
    var steps = root.querySelectorAll('.mq-loader__step');
    var i = 0;
    function light() {
      if (i < steps.length) { steps[i].classList.add('is-on'); i += 1; activeTimers.push(setTimeout(light, 650)); }
    }
    light();
    activeTimers.push(setTimeout(function () { advance(); }, 3000));
  };

  // ---------- P14 RÉSULTAT ----------
  VIEWS.result = function () {
    var axis = state.reco ? state.reco.axis : 'energie';
    var r = RESULTS[axis];
    var ageLabel = AGE_LABELS[state.answers.q_age];
    var intro = ageLabel ? 'Les hommes de ' + esc(ageLabel) + ' comme toi sont nombreux à vivre exactement ça. ' : '';
    var urgency = state.answers.q_anciennete === '>1an'
      ? ' Et comme ça dure depuis plus d\'un an, ton corps puise dans ses réserves depuis trop longtemps.'
      : '';
    var recoList = r.reco.map(function (li) { return '<li>' + li + '</li>'; }).join('');
    var showBis = state.answers.q_deja_essaye === 'oui-rien';
    return '' +
      '<section class="mq-screen mq-result">' +
        '<h2 class="mq-h2">Ton bilan énergie est prêt.</h2>' +
        '<div class="mq-diag">' +
          '<div class="mq-diag__row"><span>Facteur principal</span><strong>' + esc(r.facteur) + '</strong></div>' +
          '<div class="mq-diag__row"><span>Niveau d\'impact</span><strong>MODÉRÉ</strong></div>' +
          '<div class="mq-diag__row"><span>Cause racine</span><strong>' + esc(r.cause) + '</strong></div>' +
          '<div class="mq-diag__row"><span>Levier prioritaire</span><strong class="mq-diag__lever">' + esc(r.stackLabel) + '</strong></div>' +
        '</div>' +
        '<p class="mq-sub">' + intro + esc(r.body) + urgency + '</p>' +
        '<p class="mq-reco-title">Ton levier prioritaire : le <strong>' + esc(r.stackLabel) + '</strong>.</p>' +
        '<ul class="mq-reco-list">' + recoList + '</ul>' +
        (showBis ? '<div class="mq-callout">' + esc(r.bisglycinate) + '</div>' : '') +
        '<button class="mq-btn" data-action="continue">Voir ce qui est possible →</button>' +
      '</section>';
  };

  // ---------- P15 PROJECTION DATÉE ----------
  VIEWS.projection = function () {
    return '' +
      '<section class="mq-screen mq-proj">' +
        '<h2 class="mq-h2">Le levier qui peut changer ton quotidien.</h2>' +
        '<p class="mq-sub">D\'après tes réponses, beaucoup d\'hommes au profil similaire ressentent une vraie différence dès les premières semaines — souvent avant le <strong>' + esc(plus30Days()) + '</strong>.</p>' +
        '<div class="mq-graph">' +
          '<svg viewBox="0 0 320 180" width="100%" role="img" aria-label="Projection énergie / récupération">' +
            '<line x1="40" y1="20" x2="40" y2="150" stroke="#ece7e1" stroke-width="2"/>' +
            '<line x1="40" y1="150" x2="310" y2="150" stroke="#ece7e1" stroke-width="2"/>' +
            '<line x1="40" y1="95" x2="310" y2="95" stroke="#f4efe9" stroke-width="1" stroke-dasharray="4 4"/>' +
            '<path d="M55 95 C 150 92, 210 55, 295 30" fill="none" stroke="#FE6201" stroke-width="3" stroke-linecap="round"/>' +
            '<circle cx="55" cy="95" r="5" fill="#130600"/>' +
            '<circle cx="295" cy="30" r="6" fill="#FE6201"/>' +
            '<text x="62" y="112" font-size="11" fill="#6b6258">TU ES ICI</text>' +
            '<text x="232" y="24" font-size="11" fill="#FE6201" font-weight="700">OBJECTIF</text>' +
            '<text x="44" y="166" font-size="10" fill="#6b6258">AUJ</text>' +
            '<text x="130" y="166" font-size="10" fill="#6b6258">+10j</text>' +
            '<text x="200" y="166" font-size="10" fill="#6b6258">+20j</text>' +
            '<text x="272" y="166" font-size="10" fill="#6b6258">+30j</text>' +
          '</svg>' +
        '</div>' +
        '<p class="mq-trust">Projection indicative. Les résultats varient selon les individus et ne sont pas garantis.</p>' +
        '<button class="mq-btn" data-action="to-offer">Voir mon protocole →</button>' +
      '</section>';
  };

  // ---------- Helpers produits ----------
  function getProduct(handle) { return (CFG.products && CFG.products[handle]) || null; }
  function recoBundle() { return state.reco ? getProduct(state.reco.bundle) : null; }

  // ---------- P16 OFFRE + CAPTURE HYBRIDE ----------
  VIEWS.offer = function () {
    var axis = state.reco ? state.reco.axis : 'energie';
    var r = RESULTS[axis];
    var pct = Number(CFG.discountPct) || 0;
    var bundle = recoBundle();

    // On affiche TOUJOURS le stack (jamais de produit seul). Si l'objet produit
    // n'est pas chargé, on retombe sur le libellé du stack — pas sur ses composants.
    var title = bundle ? bundle.title : r.stackLabel;
    var image = bundle && bundle.image ? bundle.image : '';
    var cardInner = '<div class="mq-card__row">' +
      (image ? '<img class="mq-card__img" src="' + esc(image) + '" alt="' + esc(title) + '">' : '<span class="mq-card__img"></span>') +
      '<div><strong>' + esc(title) + '</strong></div></div>';
    var priceCents = bundle ? Number(bundle.price) : 0;
    var discounted = Math.round(priceCents * (1 - pct / 100));
    var priceBlock = priceCents > 0
      ? '<div class="mq-price">' + money(discounted) + (priceCents > discounted ? '<span class="mq-price__old">' + money(priceCents) + '</span>' : '') + '</div>'
      : '';
    var recoList = r.reco.map(function (li) { return '<li>' + li + '</li>'; }).join('');

    return '' +
      '<section class="mq-screen mq-offer">' +
        (pct ? '<div class="mq-urgency">⚡ -' + esc(pct) + '% réservé à ton profil</div>' : '') +
        '<h2 class="mq-h2">Ton protocole personnalisé : ' + esc(r.stackLabel) + '</h2>' +
        '<p class="mq-sub">D\'après ton profil, le <strong>' + esc(r.stackLabel) + '</strong> est le levier le plus pertinent pour toi.</p>' +
        '<ul class="mq-reco-list">' + recoList + '</ul>' +
        '<div class="mq-card">' + cardInner + priceBlock + '</div>' +
        '<button class="mq-btn" data-action="buy">Voir mon Stack →</button>' +
        '<p class="mq-guarantee">Satisfait ou remboursé 30 jours. Si tu ne ressens pas la différence, on te rembourse.</p>' +
        '<button class="mq-cta-secondary" data-action="reveal-email">Pas encore prêt ? Reçois ton protocole détaillé + ton code promo par email →</button>' +
        '<form id="mq-email-form" class="mq-email-form" novalidate hidden>' +
          '<input class="mq-field" type="email" name="email" inputmode="email" autocomplete="email" placeholder="Ton email" required>' +
          '<p class="mq-error" id="mq-email-error" hidden>Entre un email valide.</p>' +
          '<button class="mq-btn mq-btn--ghost" type="submit">Recevoir mon protocole</button>' +
        '</form>' +
        '<p class="mq-trust" id="mq-email-ok" hidden>C\'est envoyé ✅ Ton protocole et ton code ' + esc(CFG.discountCode) + ' arrivent dans ta boîte mail.</p>' +
      '</section>';
  };
  VIEWS.offer.after = function () {
    var form = root.querySelector('#mq-email-form');
    if (form) form.addEventListener('submit', onEmailSubmit);
    if (state.emailSent) {
      var sec = root.querySelector('.mq-cta-secondary');
      var ok = root.querySelector('#mq-email-ok');
      if (sec) sec.hidden = true;
      if (ok) ok.hidden = false;
    }
  };

  function goToStack() {
    if (!state.reco) return;
    var axis = state.reco.axis;
    track('quiz_cta_stack', { axe: axis, bundle: state.reco.bundle });
    // Toujours la page produit du stack (lien par handle, valide même si l'objet
    // produit n'est pas chargé). On ne renvoie jamais vers des produits seuls.
    window.location.href = L.buildProductLink(state.reco.bundle, axis, CFG.discountCode);
  }

  function revealEmail() {
    var form = root.querySelector('#mq-email-form');
    var sec = root.querySelector('.mq-cta-secondary');
    if (form) { form.hidden = false; var inp = form.querySelector('input'); if (inp) inp.focus(); }
    if (sec) sec.hidden = true;
  }

  function onEmailSubmit(e) {
    e.preventDefault();
    var form = e.currentTarget;
    var email = form.email.value.trim();
    var err = root.querySelector('#mq-email-error');
    if (!L.isValidEmail(email)) { if (err) err.hidden = false; form.email.focus(); return; }
    state.lead = { email: email };
    state.emailSent = true;
    pushKlaviyo();
    track('quiz_lead', { axe: state.reco && state.reco.axis });
    form.hidden = true;
    var ok = root.querySelector('#mq-email-ok');
    if (ok) ok.hidden = false;
  }

  function pushKlaviyo() {
    try {
      window._learnq = window._learnq || [];
      window._learnq.push(['identify', { '$email': state.lead.email }]);
      window._learnq.push(['track', 'Quiz Completed', {
        objectif: state.answers.q_concern,
        axe: state.reco ? state.reco.axis : null,
        scores: state.scores,
        stack: state.reco ? state.reco.bundle : null,
        age: state.answers.q_age,
        anciennete: state.answers.q_anciennete,
        dejaEssaye: state.answers.q_deja_essaye,
        trafficSource: state.trafficSource
      }]);
    } catch (e) { /* parcours jamais bloqué par Klaviyo */ }
  }

  // ---------- Init ----------
  track('quiz_start', { trafficSource: state.trafficSource });
  render();
})();
